import { Tenant } from '@/services/tenant';

// 缓存有效期 (5分钟)
export const TENANT_CACHE_TTL = 5 * 60 * 1000;

// 模块级缓存 - 跨组件共享
let cachedTenants: Tenant[] | null = null;
let cacheTimestamp: number = 0;

// 获取缓存的租户列表
export function getCachedTenants(): Tenant[] | null {
  if (cachedTenants && Date.now() - cacheTimestamp < TENANT_CACHE_TTL) {
    return cachedTenants;
  }
  return null;
}

// 设置缓存
export function setCachedTenants(tenants: Tenant[]) {
  cachedTenants = tenants;
  cacheTimestamp = Date.now();
}

// 清除缓存 (用于登出等场景)
export function clearTenantCache() {
  cachedTenants = null;
  cacheTimestamp = 0;
}

// 检查缓存是否有效
export function isCacheValid(): boolean {
  return (
    cachedTenants !== null && Date.now() - cacheTimestamp < TENANT_CACHE_TTL
  );
}
